export default {
  "box": "_box_1uvuqd body-2"
};